import { http } from 'services/http'
import { getRequestUrl } from 'utils/requestUtils'
import { QueryKeys } from 'constants/queries'
import { GetArtistByIdResponse, GetArtistsResponse } from 'models/artists/ApiModels'

type QueryParams = {
  id: number
}
export const getArtists = (data): Promise<GetArtistsResponse> =>
  http.get<GetArtistsResponse, GetArtistsResponse>(getRequestUrl(data?.queryKey && data?.queryKey[1], 'artists'))

export const getArtistById = ({
  queryKey: [, { id }]
}: {
  queryKey: [QueryKeys, QueryParams]
}): Promise<GetArtistByIdResponse> => http.get<GetArtistByIdResponse, GetArtistByIdResponse>(`/artists/${id}`)
